<template>
  <div id="portal-table-details">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex xs6>
          <div class="display-1">Table Record ({{ tableDetails.length }} tables)</div>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            append-icon="search"
            class="search-box"
            hide-details
            label="Search"
            single-line
            solo
            v-model="searchText"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="tableDetails"
            :loading="tableLoading"
            :search="searchText"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click.stop="editItem(props.item)">
                <td>{{ props.item.TABLE_NAME }}</td>
                <td>{{ props.item.TABLE_ROWS }}</td>
                <td>{{ props.item.CREATE_TIME }}</td>
                <td>{{ props.item.UPDATE_TIME }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'portal-table-details',
  data() {
    return {
      searchText: '',
      tableDetails: [],
      tableLoading: false,
      headers: [
        {
          text: 'Table Name',
          align: 'left',
          value: 'TABLE_NAME',
          width: '200'
        },
        {
          text: 'Records',
          align: 'left',
          value: 'TABLE_ROWS',
          width: '200'
        },
        {
          text: 'Created At',
          align: 'left',
          value: 'CREATE_TIME',
          width: '200'
        },
        {
          text: 'Updated At',
          align: 'left',
          value: 'UPDATE_TIME',
          width: '200'
        }
      ]
    }
  },
  created() {
    this.getTableDetails()
  },
  methods: {
    async getTableDetails() {
      try {
        this.tableLoading = !this.tableLoading
        const response = await axios.get(
          `portal/tableDetail/cp818446_intranet_portal`
        )
        this.tableDetails = response.data
        this.tableLoading = !this.tableLoading
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/BaseTableDetails.vue